export function filterShortcutsList(filter_str, list) {
    const filtered_list = list.reduce((acc, current) => {
        const finded_shortcuts = current.shortcuts.filter((shortcut) => shortcut.text.toLowerCase().includes(filter_str.toLowerCase()));
        if (finded_shortcuts.length > 0)
            return [...acc, { ...current, shortcuts: finded_shortcuts }];
        return acc;
    }, []);
    return filtered_list;
}
